import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { 
  COMMAND_PRIORITY_CRITICAL, 
  PASTE_COMMAND,
  $getSelection,
  $isRangeSelection,
  $createTextNode,
  $insertNodes
} from "lexical";
import { TOGGLE_LINK_COMMAND } from "@lexical/link";

export default function PasteHandlerPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event: ClipboardEvent) => {
        const clipboardData = event.clipboardData;
        if (!clipboardData) {
          return false;
        }

        // Get plain text from clipboard
        const text = clipboardData.getData("text/plain");
        if (text) {
          // Clean up the text by removing extra whitespace and normalizing line breaks
          const cleanedText = text
            .replace(/\r\n/g, "\n") // Normalize line breaks
            .replace(/\r/g, "\n") // Handle old Mac line breaks
            .replace(/\t/g, "    ") // Replace tabs with spaces
            .replace(/\n\s*\n\s*\n/g, "\n\n") // Remove excessive blank lines
            .trim(); // Remove leading/trailing whitespace

          // Check if the text is a URL
          const urlRegex = /^https?:\/\/[^\s]+$/;
          const isUrl = urlRegex.test(cleanedText);

          if (isUrl) {
            // For URLs, let the default paste behavior handle it
            // This allows Lexical's built-in link detection to work
            return false;
          } else {
            // For regular text, use Lexical's proper insertion
            editor.update(() => {
              const selection = $getSelection();
              if ($isRangeSelection(selection)) {
                const textNode = $createTextNode(cleanedText);
                $insertNodes([textNode]);
              }
            });
            return true;
          }
        }

        return false; // Allow default paste behavior for other content types
      },
      COMMAND_PRIORITY_CRITICAL
    );
  }, [editor]);

  return null;
}
